var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.stickerId
      ? _c("div", {
          staticClass: "transition-all pointer-events-none",
          class: `bg-${_vm.stickerId}`,
          attrs: { "data-grm-comp": "RoomSticker" },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }